const profile = {
    name: 'Name',
    avatar: 'Avatar',
    givenName: 'ชื่อจริง',
    familyName: 'นามสกุล',
    middleName: 'ชื่อกลาง',
    fullname: 'ชื่อเต็ม',
    nickname: 'ชื่อเล่น',
    preferredUsername: 'ชื่อผู้ใช้ที่ต้องการ',
    profile: 'โปรไฟล์',
    website: 'เว็บไซต์',
    gender: 'เพศ',
    birthdate: 'วันเกิด',
    zoneinfo: 'เขตเวลา',
    locale: 'ภาษา',
    address: {
        formatted: 'ที่อยู่',
        streetAddress: 'ที่อยู่ถนน',
        locality: 'เมือง',
        region: 'รัฐ/จังหวัด',
        postalCode: 'รหัสไปรษณีย์',
        country: 'ประเทศ',
    },
    gender_options: {
        female: 'หญิง',
        male: 'ชาย',
        prefer_not_to_say: 'ไม่ระบุ',
    },
    checkbox_value: {
        checked: 'ใช่',
        unchecked: 'ไม่',
    },
    avatar_upload: {
        upload: 'อัปโหลด',
        remove: 'ลบ',
        uploading: 'กำลังอัปโหลด...',
        hint: 'ขนาดที่แนะนำ 1:1 สูงสุด {{limit}}',
        error_file_type: 'ประเภทไฟล์ต้องเป็น {{extensions}}',
        error_file_size: 'ขนาดไฟล์ต้องไม่เกิน {{limit}}',
        error_storage_not_configured: 'ไม่สามารถอัปโหลดรูปภาพได้ โปรดลองอีกครั้งในภายหลัง',
        error_upload: 'อัปโหลดรูปภาพไม่สำเร็จ โปรดลองอีกครั้ง',
        error_save: 'ไม่สามารถบันทึกรูปภาพของคุณได้ โปรดลองอีกครั้ง',
        crop_title: 'ครอบตัดรูปภาพ',
        zoom: 'ซูม',
        error_crop: 'ครอบตัดรูปภาพไม่สำเร็จ โปรดลองอีกครั้ง',
    },
};
export default Object.freeze(profile);
